export default __webpack_public_path__ + "static/media/14.87b0f081.png";